
if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();
          
          console.log('ProductForm initialized');
  
          this.form = this.querySelector('form');
          if (!this.form) {
            console.error('No form found in product-form element');
            return;
          }
          
          console.log('Form found, adding submit listener');
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          
          if (this.variantIdInput) {
            this.variantIdInput.disabled = false;
          }
          
          //this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.cart = document.querySelector('mini-cart');
          console.log('Cart element found:', this.cart);
          
          this.submitButton = this.querySelector('[type="submit"]');
          
          // Only set submitButtonText if submitButton exists (product cards use add-to-cart elements instead)
          if (this.submitButton) {
            this.submitButtonText = this.submitButton.querySelector('span');
            if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
  
          this.hideErrors = this.dataset.hideErrors === 'true';
        }
  
        onSubmitHandler(evt) {
          console.log('🚀 Form submit handler fired!', evt);
          evt.preventDefault();
          evt.stopPropagation();
          evt.stopImmediatePropagation();
          
          if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') {
            console.log('Submit button disabled, returning');
            return;
          }
          
          console.log('Checking required fields...');
          if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) {
            console.log('❌ Required fields check failed');
            return;
          }
          console.log('✅ Required fields OK');

          this.handleErrorMessage();
          
          // Debug: Check if variant ID is selected
          const variantId = this.variantIdInput.value;
          console.log('Submitting variant ID:', variantId);
          if (!variantId) {
            console.error('No variant ID selected!');
            return;
          }

          if (this.submitButton) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
          }
          //this.querySelector('.loading__spinner').classList.remove('hidden');
  
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
  
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
  
          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              console.log('Cart add response:', response);
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
  
                if (this.submitButton) {
                  const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute('aria-disabled', true);
                  if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                }
                this.error = true;
                return;
              }
              
                            // Update cart UI first
              if (this.cart && response.sections) {
                console.log('Updating cart UI with sections:', response.sections);
                this.cart.renderContents(response);
              } else {
                console.warn('Cart not updated:', { cart: this.cart, sections: response.sections });
              }
              
              // Update button state
              this.updateButtonState(response);
              
              // Close modal/drawer if this form is inside one
              
              // Check for quick-view-drawer (details/summary structure)
              const quickViewDrawer = this.closest('quick-view-drawer');
              if (quickViewDrawer) {
                const details = quickViewDrawer.querySelector('details[open]');
                if (details) {
                  details.removeAttribute('open');
                  // Remove body classes that keep modal open
                  document.body.classList.remove('quick-view--open', 'modal-open', 'drawer-open');
                  console.log('Closed quick-view-drawer and cleaned up body classes');
                  return;
                }
              }
              
              // Check for drawer-close-button
              const drawerCloseButton = this.closest('.quick-view')?.querySelector('drawer-close-button');
              if (drawerCloseButton) {
                drawerCloseButton.click();
                console.log('Clicked drawer-close-button');
                return;
              }
              
              // Check for traditional modals
              const modal = this.closest('.modal, [role="dialog"], .product-modal, .quick-view');
              if (modal) {
                // Try different methods to close the modal
                const closeButton = modal.querySelector('.modal__close, .close, [data-close], [aria-label*="close" i], drawer-close-button');
                if (closeButton) {
                  closeButton.click();
                  console.log('Clicked modal close button');
                } else {
                  // If no close button, try hiding the modal
                  modal.style.display = 'none';
                  modal.classList.add('hidden');
                  console.log('Hid modal manually');
                  
                  // Remove modal backdrop if it exists
                  const backdrop = document.querySelector('.modal-backdrop, .overlay');
                  if (backdrop) {
                    backdrop.style.display = 'none';
                    backdrop.classList.add('hidden');
                  }
                }
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              if (this.submitButton) {
                this.submitButton.classList.remove('loading');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              }
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              //this.querySelector('.loading__spinner').classList.add('hidden');
            });
        }
  
        blockSubmitIfRequiredFieldsEmpty(event) {
          if (!(this.form instanceof HTMLFormElement)) {
            throw new Error("Expected a form element.");
          }
  
          const formId = this.form.getAttribute('id');
          const requiredFields = this.form.querySelectorAll('[required]');
          console.log('Total required fields found:', requiredFields.length);
          let allFilled = true;
          for (const field of requiredFields) {
            console.log('Field:', field.name, 'Type:', field.type);
            
            let isValid = true;
            switch (field.type) {
              case 'checkbox':
              case 'radio':
                const group = document.querySelectorAll(`input[name="${field.name}"][type="${field.type}"]`);
                const isChecked = Array.from(group).some(input => input.checked);
                isValid = isChecked;
                console.log('  Radio/checkbox group:', field.name, 'Checked:', isChecked);
                break;
              case 'select-one':
                isValid = field.value !== '';
                console.log('  Select:', field.name, 'Value:', field.value, 'Valid:', isValid);
                break;
              case 'textarea':
              case 'text':
              case 'email':
              case 'number':
              case 'url':
              default:
                isValid = field.value.trim() !== '';
                console.log('  Input:', field.name, 'Value:', field.value, 'Valid:', isValid);
                break;
            }
            if (!isValid) {
              console.error('❌ INVALID FIELD:', field.name, field.type, 'Value:', field.value);
              allFilled = false;
              field.classList.add('invalid');
            } else {
              field.classList.remove('invalid');
            }
          }
      
          if (!allFilled) {
            event.preventDefault();
            this.handleErrorMessage(theme.accessibilityStrings.fillInAllLineItemPropertyRequiredFields);
            return false;
          }
          return true;
        }
        
        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;
  
          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
  
        toggleSubmitButton(disable = true, text) {
          if (!this.submitButton) return;
          
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text && this.submitButtonText) this.submitButtonText.textContent = text;
          } else {
            this.submitButton.removeAttribute('disabled');
            if (this.submitButtonText) this.submitButtonText.textContent = theme.variantStrings.addToCart;
          }
        }
  
        updateButtonState(response) {
          // Dispatch custom event to update card state
          const cartUpdateEvent = new CustomEvent('cartUpdate', {
            detail: {
              source: 'product-form',
              productVariantId: this.variantIdInput.value,
              cartData: response
            }
          });
          document.dispatchEvent(cartUpdateEvent);
          
          // Update the specific card's button state
          const cardControls = this.closest('.card-wrapper')?.querySelector('.card__cart-controls');
          if (cardControls) {
            const addButton = cardControls.querySelector('.card__add-to-cart-btn');
            const qtyControls = cardControls.querySelector('.card__quantity-controls');
            
            if (addButton && qtyControls) {
              // Hide add button, show quantity controls
              addButton.style.display = 'none';
              qtyControls.style.display = 'flex';
              qtyControls.querySelector('.card__qty-display').textContent = '1';
            }
          }
        }

        get variantIdInput() {
          return this.form.querySelector('[name=id]');
        }
      }
    );
  }
  